export const addExtraStyles = (doc: Document) => {
  const extraSheet = new CSSStyleSheet();
  extraSheet.replaceSync(`#lanyard_root * {font-family: "Lato", sans-serif !important;}`);

  // Combine the existing sheets and new one
  doc.adoptedStyleSheets = [...doc.adoptedStyleSheets, extraSheet];
};
